module.exports = __webpack_public_path__ + "static/fonts/PingFangSC_Regular.5bd6da04.otf";